export class Questions {
    answer:string;
    answeredBy:string;
    eventId:string;
    from:string;
    isQuestionAnswered:boolean = false;
    likesCount: number;
    question:string;
    sessionId:string;
}


// WEBPACK FOOTER //
// /app/src/app/core/models/question-answer.ts